import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-5 px-6 bg-midnight-light border-t border-gold/10" data-id="element-50">
      <div className="max-w-3xl mx-auto text-center" data-id="element-51">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="font-cinzel text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-2 tracking-[0.1em]" data-id="element-52">
          EL TRONO ES TUYO.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.1
      }} className="font-sans text-sm text-gray-500 font-light mb-4 tracking-wide" data-id="element-53">
          La única pregunta es cuándo vas a reclamarlo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="w-full max-w-sm mx-auto" data-id="element-54">
          <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full py-5 bg-gold text-black font-sans font-semibold text-sm tracking-[0.15em] uppercase text-center hover:bg-gold-light transition-colors duration-300" data-id="element-55">
            acceso inmediato — $14.990
          </a>
          <p className="mt-3 font-sans text-[10px] text-gray-600 tracking-[0.2em] uppercase" data-id="element-56">
            Acceso inmediato • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}